import React, { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import "./HotelRegistration.css";
import { Link, useNavigate } from "react-router-dom";
import Blue_btn from "../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../common_components/common_btn/blue_border_button/Blue_border_button";
import HotelRegistration_step_1 from "./hotelRegistration_step_1/HotelRegistration_step_1";
import HotelRegistration_step_5 from "./hotelRegistration_step_5/HotelRegistration_step_5";
import HotelRegistration_step_4 from "./hotelRegistration_step_4/HotelRegistration_step_4";
import HotelRegistration_step_3 from "./hotelRegistration_step_3/HotelRegistration_step_3";
import HotelRegistration_step_2 from "./hotelRegistration_step_2/HotelRegistration_step_2";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

import {
  Create1,
  GetRegistration1,
  Create2,
  GetRegistration2,
  Create3,
  GetRegistration3,
  Create4, // ✅ ADD
  GetRegistration4, // ✅ ADD
  Create5, // ✅ ADD
  GetRegistration5, // ✅ ADD
} from "../../../features/admin/internship/hotelauth/Slice";
import { useDispatch, useSelector } from "react-redux";

const HotelRegistration = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
    setError,
  } = useForm();

  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  const { getUserData1 } = useSelector(
    (state) => state.internship.hotelregistration,
  );
  const { getUserData2 } = useSelector(
    (state) => state.internship.hotelregistration,
  );
  const { getUserData3 } = useSelector(
    (state) => state.internship.hotelregistration,
  );
  const { getUserData4 } = useSelector(
    (state) => state.internship.hotelregistration,
  );

  useEffect(() => {
    if (getUserData1) {
      Object.keys(getUserData1).forEach((key) => {
        if (key === "show_password") {
          setValue("password", getUserData1.show_password);
        } else {
          setValue(key, getUserData1[key]);
        }
      });

      if (getUserData1.last_completed_step) {
        setStep(Math.min(getUserData1.last_completed_step + 1, 5));
      }
    }
  }, [getUserData1, setValue]);

  useEffect(() => {
    if (getUserData2) {
      Object.keys(getUserData2).forEach((key) => {
        setValue(key, getUserData2[key]);
      });
    }
  }, [getUserData2, setValue]);

  useEffect(() => {
    if (getUserData3) {
      Object.keys(getUserData3).forEach((key) => {
        setValue(key, getUserData3[key]);
      });
    }
  }, [getUserData3, setValue]);

  useEffect(() => {
    if (getUserData4) {
      Object.keys(getUserData4).forEach((key) => {
        setValue(key, getUserData4[key]);
      });
    }
  }, [getUserData4, setValue]);

  const { getUserData5 } = useSelector(
    (state) => state.internship.hotelregistration,
  );

  useEffect(() => {
    if (getUserData5) {
      Object.keys(getUserData5).forEach((key) => {
        setValue(key, getUserData5[key]);
      });
    }
  }, [getUserData5, setValue]);

  useEffect(() => {
    const storedUserId = Cookies.get("hotel_user_id");
    if (storedUserId) {
      dispatch(GetRegistration1(storedUserId));
      dispatch(GetRegistration2(storedUserId));
      dispatch(GetRegistration3(storedUserId));
      dispatch(GetRegistration4(storedUserId));
      dispatch(GetRegistration5(storedUserId));
    }
  }, [dispatch]);

  const onSubmit = async (data) => {
    try {
      const userId = Cookies.get("hotel_user_id");

      // ================= STEP 1 =================
      if (step === 1) {
        const formData = new FormData();
        const existingUserId = Cookies.get("hotel_user_id");

        if (existingUserId) {
          formData.append("user_id", existingUserId);
        }

        formData.append("name", data.name);
        formData.append("email", data.email);
        formData.append("contact_no", data.contact_no);
        formData.append("password", data.password);
        formData.append("role_id", data.role_id);

        try {
          const res = await dispatch(Create1(formData)).unwrap();
          const createdUserId = res?.data?.user_id;

          if (!existingUserId && createdUserId) {
            Cookies.set("hotel_user_id", createdUserId);
          }

          await dispatch(GetRegistration1(existingUserId || createdUserId));
          setStep(2);
          return;
        } catch (err) {
          const backendMessage =
            err?.errors || err?.message || "Registration failed";

          if (backendMessage.toLowerCase().includes("email")) {
            setError("email", { type: "manual", message: backendMessage });
          } else if (backendMessage.toLowerCase().includes("contact")) {
            setError("contact_no", { type: "manual", message: backendMessage });
          }
          return;
        }
      }

      // ================= STEP 2 =================
      if (step === 2) {
        const formData = new FormData();
        const userId = Cookies.get("hotel_user_id");

        formData.append("user_id", userId);
        formData.append("siret", data.siret);
        formData.append("trade_name", data.trade_name);
        formData.append("siren", data.siren);
        formData.append("activity_code", data.activity_code);
        formData.append("legal_form", data.legal_form);
        formData.append("number_of_employee", data.number_of_employee);
        formData.append("internship_capacity", data.internship_capacity);
        formData.append("registered_address", data.registered_address);

        try {
          await dispatch(Create2(formData)).unwrap();

          await dispatch(GetRegistration2(userId)); // ✅ PREFILL SUPPORT
          setStep(3);
          return;
        } catch (err) {
          const backendErrors = err?.errors;

          if (backendErrors) {
            Object.keys(backendErrors).forEach((field) => {
              setError(field, {
                type: "manual",
                message: backendErrors[field].msg || "Invalid value",
              });
            });
          }
          return;
        }
      }

      // ================= STEP 3 =================
      if (step === 3) {
        const formData = new FormData();
        const userId = Cookies.get("hotel_user_id");

        formData.append("user_id", userId);
        formData.append("establishment_name", data.establishment_name);
        formData.append("establishment_web_url", data.establishment_web_url);
        formData.append("establishment_address", data.establishment_address);
        formData.append(
          "establishment_current_address",
          data.establishment_current_address,
        );
        formData.append("accomodation_street", data.accomodation_street);
        formData.append(
          "accomodation_postal_code",
          data.accomodation_postal_code,
        );
        formData.append("accomodation_country", data.accomodation_country);
        formData.append("accomodation_city", data.accomodation_city);

        try {
          await dispatch(Create3(formData)).unwrap();

          await dispatch(GetRegistration3(userId)); //  PREFILL SUPPORT
          setStep(4); // move to next step
          return;
        } catch (err) {
          const backendErrors = err?.errors;

          if (backendErrors) {
            Object.keys(backendErrors).forEach((field) => {
              setError(field, {
                type: "manual",
                message: backendErrors[field].msg || "Invalid value",
              });
            });
          }
          return;
        }
      }

      // ================= STEP 4 =================
      if (step === 4) {
        const formData = new FormData();
        const userId = Cookies.get("hotel_user_id");

        formData.append("user_id", userId);
        formData.append("first_name", data.first_name);
        formData.append("last_name", data.last_name);
        formData.append("job_title", data.job_title);
        formData.append("prof_email", data.prof_email);
        formData.append("prof_contact_no", data.prof_contact_no);

        try {
          await dispatch(Create4(formData)).unwrap();

          await dispatch(GetRegistration4(userId)); // ✅ PREFILL SUPPORT
          setStep(5); // move to final step
          return;
        } catch (err) {
          const backendErrors = err?.errors;

          if (backendErrors) {
            Object.keys(backendErrors).forEach((field) => {
              setError(field, {
                type: "manual",
                message: backendErrors[field].msg || "Invalid value",
              });
            });
          }
          return;
        }
      }

      // ================= STEP 5 (FINAL) =================
      if (step === 5) {
        const userId = Cookies.get("hotel_user_id");

        const payload = {
          user_id: userId,
          first_name: data.first_name,
          last_name: data.last_name,
          job_title: data.job_title,
          prof_email: data.prof_email,
          prof_contact_no: data.prof_contact_no,
          authorized_signatory: data.authorized_signatory ? 1 : 0, // ✅ boolean → int
        };

        const res = await dispatch(Create5(payload)).unwrap();

        if (res?.success) {
          await dispatch(GetRegistration5(userId));

          // ✅ REMOVE COOKIE
          Cookies.remove("hotel_user_id");

          // ✅ SUCCESS POPUP + REDIRECT
          Swal.fire({
            icon: "success",
            title: "Registration Completed",
            text: "Hotel registration completed successfully.",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
            didClose: () => {
              navigate("/");
            },
          });
        }

        return;
      }

      // ================= STEP 2–4 =================
      if (step < 5) {
        setStep(step + 1);
        return;
      }

      // ================= STEP 5 (FINAL) =================
      if (step === 5) {
        Cookies.remove("hotel_user_id");

        Swal.fire({
          icon: "success",
          title: "Registration Completed",
          text: "Hotel registration completed successfully.",
          timer: 2000,
          showConfirmButton: false,
          didClose: () => navigate("/"),
        });
      }
    } catch (error) {
      console.error("Hotel registration error:", error);
    }
  };

  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  return (
    <>
      <section className="HotelRegistration common_step_form_wrapper">
        <div className="login_form_div">
          <div className="login_card">
            <div className="hotel-form-card">
              <section className="login_wrapper">
                <div className={`login_div`}>
                  <div className="row justify-content-center me-0 ms-0">
                    <div className="col-lg-6 col-md-11 order-2 order-lg-1 ">
                      <div className="left_content">
                        <h1 className="main_heading">
                          From recruitment to contracts All in One Place
                        </h1>

                        <p className="main_text">
                          Seamlessly apply, hire, & manage every step of the
                          internship process with confidence.
                        </p>

                        <div className="feature_box">
                          <h5 className="feature_heading">SEAMLESS PROCESS</h5>
                          <p className="feature_text">
                            Submit your documents online, get them reviewed, and
                            receive approvals faster
                          </p>
                        </div>

                        <div className="feature_box">
                          <h5 className="feature_heading">ALL IN ONE</h5>
                          <p className="feature_text">
                            Apply for internships, post offers, upload CDD
                            documents, and track your applications
                          </p>
                        </div>

                        <div className="feature_box">
                          <h5 className="feature_heading">
                            TRANSPARENT & RELIABLE
                          </h5>
                          <p className="feature_text">
                            Every step is verified by experts available 24/7 to
                            guide you
                          </p>
                        </div>

                        <h2 className="tagline">
                          We Nurture Talent Across The Globe
                        </h2>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-11 order-1 order-lg-2 ">
                      <div className="login_card">
                        <div className="login_card_step_content_holder">
                          {/* LOGO */}
                          <Link to="/">
                            <div className="logo_box mb-4">
                              <img
                                src="/assets/images/login-page/login-logo.png"
                                alt="logo"
                                className="login_img"
                              />
                            </div>
                          </Link>

                          <h3 className="welcome_title">Hotel Registration</h3>
                          <p className="choose_text">
                            (All information is required)
                          </p>

                          <Link to="/">
                            <button className="back_btn">
                              <i className="fa-solid fa-arrow-left"></i> Back
                            </button>
                          </Link>

                          <div className="hotel-progress-wrapper">
                            <ProgressBar
                              now={(step / 5) * 100}
                              className="hotel-progress"
                            />
                            <span className="progress-steps-text">
                              {step} / 5
                            </span>
                          </div>

                          {/* STEP A */}

                          <form onSubmit={handleSubmit(onSubmit)}>
                            {step === 1 && (
                              <HotelRegistration_step_1
                                register={register}
                                errors={errors}
                                setValue={setValue}
                              />
                            )}

                            {/* STEP B */}
                            {step === 2 && (
                              <HotelRegistration_step_2
                                register={register}
                                errors={errors}
                                setValue={setValue}
                              />
                            )}

                            {/* STEP C */}
                            {step === 3 && (
                              <HotelRegistration_step_3
                                register={register}
                                errors={errors}
                                setValue={setValue}
                              />
                            )}

                            {/* STEP D */}
                            {step === 4 && (
                              <HotelRegistration_step_4
                                register={register}
                                errors={errors}
                                setValue={setValue}
                              />
                            )}

                            {/* STEP E */}
                            {step === 5 && (
                              <>
                                <HotelRegistration_step_5
                                  register={register}
                                  errors={errors}
                                />
                              </>
                            )}

                            {/* BUTTONS */}
                            <div className="btn-group">
                              {step > 1 && (
                                <Blue_border_button
                                  button_text="Back"
                                  onClick={prevStep}
                                />
                              )}

                              {step < 5 ? (
                                <Blue_btn btn_text="Next" type="submit" />
                              ) : (
                                <Blue_btn btn_text="Submit" type="submit" />
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HotelRegistration;
